module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes],
    attrs: {
      "refs": "box-wrapper"
    }
  }, [_c('header', {
    ref: "mainHeader",
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("NTI")])]), _vm._v(" "), _vm._v("\n      PMVC - CMC\n    ")]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.user_current.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user_current.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.user_current.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user_current.displayName))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.user_current.setor))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.hasPermission('usuario.updatePassword')),
      expression: "this.hasPermission('usuario.updatePassword')"
    }],
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "to": "/cadastros/usuarios/alterar-senha"
    }
  }, [_vm._v("Alterar Senha")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("Sair")])])])])])])])])], 1), _vm._v(" "), _c('aside', {
    ref: "mainSideBar",
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('sidebar-menu')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper",
    style: ({
      'min-height': _vm.fullHeight + 'px'
    })
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        CMC\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    ref: "mainFooter",
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("\n      Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("NTI")]), _vm._v(".\n    ")]), _vm._v(" Todos os direitos reservados.\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0b8fd15c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 792
// module chunks = 0